export default __webpack_public_path__ + "static/media/flask.d7668819.svg";